import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["classes", "point"];
import React, { useContext } from 'react';
import Tile from '../tiles/Tile';
import { getBeginOfYear, getEndOfYear } from '../../utils/dates';
import CalendarPickerContext from '../../context/CalendarPickerContext';
var className = 'ap-single-year';
var Year = function Year(_ref) {
  var classes = _ref.classes,
    point = _ref.point,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useContext = useContext(CalendarPickerContext),
    dateValidator = _useContext.dateValidator,
    minDate = _useContext.minDate,
    maxDate = _useContext.maxDate,
    maxDetail = _useContext.maxDetail,
    disabledDays = _useContext.disabledDays,
    disabledDates = _useContext.disabledDates,
    disabledRanges = _useContext.disabledRanges,
    mergedDisabledDatesIntervals = _useContext.mergedDisabledDatesIntervals;
  return /*#__PURE__*/React.createElement(Tile, _extends({}, otherProps, {
    classes: [].concat(classes, [className]),
    maxDateTransform: getEndOfYear,
    minDateTransform: getBeginOfYear,
    view: "decade",
    dateValidator: dateValidator,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail,
    disabledDays: disabledDays,
    disabledDates: disabledDates,
    disabledRanges: disabledRanges,
    mergedDisabledDatesIntervals: mergedDisabledDatesIntervals
  }), point);
};
export default Year;